import type { AdminTab } from './types';

/**
 * 管理后台的展示文案。接口值、注册表 id 与路由路径保持英文不动，
 * 这里只负责把它们映射成界面上的中文标签。
 */
export const TAB_LABELS: Record<AdminTab, string> = {
  Users: '用户', Plans: '套餐', Vendors: '模型厂商', Models: '模型', ImageModels: '生图模型', Channels: '渠道',
  ImageChannels: '生图渠道', ImageRoutes: '生图路由', Orders: '订单', Usage: '用量',
  Accounting: '计费', Ledger: '流水', Audit: '审计', TTS: 'TTS', Appearance: '外观皮肤', Operations: '运维', Security: '登录安全',
};

export const HISTORY_LABELS: Record<'Ledger' | 'Usage' | 'Orders', string> = { Ledger: '流水', Usage: '用量', Orders: '订单' };

export const roleLabels: Record<string, string> = { user: '普通用户', admin: '管理员' };
export const userStatusLabels: Record<string, string> = { active: '正常', disabled: '已停用', pending: '待验证' };
export const orderStatusLabels: Record<string, string> = { pending: '待支付', paid: '已支付', expired: '已过期' };
export const ledgerTypeLabels: Record<string, string> = {
  admin_adjustment: '管理员调整', tts_subscription: '语音订阅', recharge: '充值',
  reservation: '模型请求预扣', reservation_settlement: '模型请求结算', refund: '退款',
};
export const accountingStatusLabels: Record<string, string> = {
  settlement_pending: '待结算', settlement_failed: '结算失败', reconciliation_required: '需人工核对',
  preparing: '准备中', running: '进行中',
};
export const auditActionLabels: Record<string, string> = { 'wallet.adjust': '调整余额', 'payment.notify.rejected': '支付回调被拒', 'passkey.register': '添加通行密钥', 'passkey.login': '通行密钥登录', 'passkey.remove': '移除通行密钥' };

/** 未知取值原样显示，避免把服务端新增的枚举吞掉。 */
export function valueLabel(labels: Record<string, string>, value: string): string {
  return Object.hasOwn(labels, value) ? labels[value]! : value;
}
